export default __webpack_public_path__ + "static/media/docs-stress-resistant-head.75bb60b1.png";